module.exports = __webpack_public_path__ + "img/single-neutral-actions-information.a5e19f42.svg";